<template>
  <div class="home-web">
    <Carousel
      v-model="value3"
      :autoplay="true"
      :radius-dot="true"
      trigger="hover"
      arrow="never"
      :autoplay-speed="6000"
    >
      <!--      <CarouselItem>-->
      <!--        <div class="demo-carousel">-->
      <!--          <a href="https://www.redteago.com/" target="_blank">-->
      <!--            <img :src="banner5" />-->
      <!--          </a>-->
      <!--        </div>-->
      <!--      </CarouselItem>-->
      <CarouselItem>
        <div class="demo-carousel">
          <router-link to="/CaaS">
            <img :src="banner1" />
          </router-link>
        </div>
      </CarouselItem>
      <CarouselItem>
        <div class="demo-carousel">
          <router-link to="/RedteaReady">
            <img :src="banner2" />
          </router-link>
        </div>
      </CarouselItem>
      <CarouselItem>
        <div class="demo-carousel">
          <router-link to="/RedteaGo">
            <img :src="banner3" />
          </router-link>
        </div>
      </CarouselItem>
      <CarouselItem>
        <div class="demo-carousel">
          <router-link to="/RedteaSIM">
            <img :src="banner4" />
          </router-link>
        </div>
      </CarouselItem>
    </Carousel>

    <div class="facts">
      <div class="facts-1 facts-img">
        <p class="facts-title">{{ $t("Home.facts.number1") }}</p>
        <p class="facts-content">{{ $t("Home.facts.text1") }}</p>
      </div>
      <div class="facts-2 facts-img">
        <p class="facts-title">{{ $t("Home.facts.number2") }}</p>
        <p class="facts-content">{{ $t("Home.facts.text2") }}</p>
      </div>
      <div class="facts-3 facts-img">
        <p class="facts-title">{{ $t("Home.facts.number3") }}</p>
        <p class="facts-content">{{ $t("Home.facts.text3") }}</p>
      </div>
      <div class="facts-4 facts-img">
        <p class="facts-title">{{ $t("Home.facts.number4") }}</p>
        <p class="facts-content">{{ $t("Home.facts.text4") }}</p>
      </div>
      <div class="facts-4 facts-img">
        <p class="facts-title">{{ $t("Home.facts.number5") }}</p>
        <p class="facts-content">{{ $t("Home.facts.text5") }}</p>
      </div>
    </div>

    <div class="power">
      <p class="power-title">{{ $t("Home.title") }}</p>
      <p class="power-content">{{ $t("Home.position") }}</p>
    </div>

    <div class="cores">
      <p class="title">{{ $t("Home.connect.title") }}</p>
      <div class="cores-flexBox">
        <div class="cores-imgBox">
          <img src="../assets/web/Plug & Play Connnectivity.svg" />
          <p class="cores-title">{{ $t("Home.connect.title1") }}</p>
          <p class="cores-content">{{ $t("Home.connect.text1") }}</p>
        </div>
        <div class="cores-imgBox">
          <img src="../assets/web/Always-on Connectivity.svg" />
          <p class="cores-title">{{ $t("Home.connect.title2") }}</p>
          <p class="cores-content">{{ $t("Home.connect.text2") }}</p>
        </div>
        <div class="cores-imgBox">
          <img src="../assets/web/Management.svg" />
          <p class="cores-title">{{ $t("Home.connect.title3") }}</p>
          <p class="cores-content">{{ $t("Home.connect.text3") }}</p>
        </div>
        <div class="cores-imgBox">
          <img src="../assets/web/Scalable.svg" />
          <p class="cores-title">{{ $t("Home.connect.title4") }}</p>
          <p class="cores-content">{{ $t("Home.connect.text4") }}</p>
        </div>
      </div>
    </div>

    <div class="Caas">
      <div class="left">
        <p class="left-title">{{ $t("Home.caas.title") }}</p>
        <p class="left-content">{{ $t("Home.caas.des") }}</p>
        <router-link to="/Caas">
          <p class="left-more">{{ $t("learnMore") }}&nbsp;&nbsp;></p>
        </router-link>
      </div>
      <div class="right">
        <div class="img-box img1">
          <img src="../assets/web/Virtualization.svg" />
          <div>
            <p class="right-title">{{ $t("Home.caas.title1") }}</p>
            <p class="right-content">{{ $t("Home.caas.text1") }}</p>
          </div>
        </div>
        <div class="img-box img2">
          <img src="../assets/web/Abstraction.svg" />
          <div>
            <p class="right-title">{{ $t("Home.caas.title2") }}</p>
            <p class="right-content">{{ $t("Home.caas.text2") }}</p>
          </div>
        </div>
        <div class="img-box img3">
          <img src="../assets/web/Openness.svg" />
          <div>
            <p class="right-title">{{ $t("Home.caas.title3") }}</p>
            <p class="right-content">{{ $t("Home.caas.text3") }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="product">
      <div class="product-title">{{ $t("Home.product.title") }}</div>
      <div class="product-content">{{ $t("Home.product.des") }}</div>
      <div class="flex-box">
        <div class="img-box">
          <img
            src="../assets/web/RedteaGo 1.png"
            style="width: 2.2rem; margin-top: -0.19rem"
          />
          <p class="img-title">{{ $t("Home.product.title1") }}</p>
          <p class="img-content">{{ $t("Home.product.text1") }}</p>
          <router-link to="/RedteaGo">
            <p class="img-more">{{ $t("learnMore") }}&nbsp;&nbsp;></p>
          </router-link>
        </div>
        <div class="img-box">
          <img src="../assets/web/Redtea ready.png" />
          <p class="img-title" style="margin-top: 0.09rem">
            {{ $t("Home.product.title2") }}
          </p>
          <p class="img-content">{{ $t("Home.product.text2") }}</p>
          <router-link to="/RedteaReady">
            <p class="img-more">{{ $t("learnMore") }}&nbsp;&nbsp;></p>
          </router-link>
        </div>
        <div class="img-box">
          <img src="../assets/web/RedteaSIM.png" />
          <p class="img-title" style="margin-top: 0.09rem">
            {{ $t("Home.product.title3") }}
          </p>
          <p class="img-content">{{ $t("Home.product.text3") }}</p>
          <router-link to="/RedteaSIM">
            <p class="img-more">{{ $t("learnMore") }}&nbsp;&nbsp;></p>
          </router-link>
        </div>
      </div>
    </div>

    <div class="about">
      <p class="about-title">{{ $t("Home.aboutTitle") }}</p>
      <p class="about-content">{{ $t("Home.aboutDes") }}</p>
      <router-link to="/about">
        <p class="about-more">{{ $t("learnMore") }}&nbsp;&nbsp;></p>
      </router-link>
    </div>

    <div class="about-redtea">
      <div style="width: 64%; margin: auto">
        <Carousel
          v-model="value2"
          :autoplay="true"
          :autoplay-speed="9000"
          :dots="'none'"
          :arrow="'always'"
        >
          <CarouselItem>
            <div class="demo-carousel">
              <p class="demo-title">{{ $t("Home.say.title") }}</p>
              <p class="demo-content">
                "{{ $t("Home.say.content1") }}
                <a
                  href="https://ims.ul.com/rise-virtual-sim-0"
                  target="_Blank"
                  style="color: rgba(207, 42, 42, 1)"
                  >{{ $t("Home.say.click") }}</a
                >"
              </p>
              <p class="demo-name">{{ $t("Home.say.author1") }}</p>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div class="demo-carousel">
              <p class="demo-title">{{ $t("Home.say.title") }}</p>
              <p class="demo-content">
                "{{ $t("Home.say.content2") }}
                <a
                  href="https://www.gsma.com/membership/membership-types/associate-membership/"
                  target="_Blank"
                  style="color: rgba(207, 42, 42, 1)"
                  >{{ $t("Home.say.click") }}</a
                >"
              </p>
              <p class="demo-name">{{ $t("Home.say.author2") }}</p>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div class="demo-carousel">
              <p class="demo-title">{{ $t("Home.say.title") }}</p>
              <p class="demo-content">
                "{{ $t("Home.say.content3") }}
                <a
                  href="https://globalcarrier.telekom.com/newsroom/events/events/gsma-was5"
                  target="_Blank"
                  style="color: rgba(207, 42, 42, 1)"
                  >{{ $t("Home.say.click") }}</a
                >"
              </p>
              <p class="demo-name">{{ $t("Home.say.author3") }}</p>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div class="demo-carousel">
              <p class="demo-title">{{ $t("Home.say.title") }}</p>
              <p class="demo-content">"{{ $t("Home.say.content4") }}"</p>
              <p class="demo-name">{{ $t("Home.say.author4") }}</p>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div class="demo-carousel">
              <p class="demo-title">{{ $t("Home.say.title") }}</p>
              <p class="demo-content">"{{ $t("Home.say.content5") }}"</p>
              <p class="demo-name">{{ $t("Home.say.author5") }}</p>
            </div>
          </CarouselItem>
        </Carousel>
      </div>
    </div>

    <!-- ihone esim app跳转模态框 -->
    <Modal v-model="modal22" footer-hide width="70" class="web-iphone">
      <Row>
        <Col span="24" class="modal-title">{{ $t("iphoneBox.title") }}</Col>
      </Row>
      <Row>
        <Col class="modal-line"></Col>
      </Row>
      <Row class="web-iphone-box">
        <img src="../assets/手机_web.png" class="mobile-img" />
        <Col span="14">
          <a
            href="https://apps.apple.com/app/redteago/id1492864476"
            target="_blank"
          >
            <img src="../assets/download_web.png" class="down-img" />
          </a>
        </Col>
        <Col span="10" class="right-box">
          <p class="iphone-title-2">{{ $t("iphoneBox.title1") }}</p>
          <p class="iphone-lists">{{ $t("iphoneBox.text1") }}</p>
          <p class="iphone-lists">{{ $t("iphoneBox.text2") }}</p>
          <p class="iphone-lists">{{ $t("iphoneBox.text3") }}</p>
          <!--          <a href="https://www.redteago.com/" target="_blank">-->
          <!--            <div class="more">{{ $t("iphoneBox.more") }}</div>-->
          <!--          </a>-->
          <p class="iphone-bottom">{{ $t("iphoneBox.chOnly") }}</p>
        </Col>
      </Row>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "home-web",
  data() {
    return {
      value3: 0,
      value2: 0,
      modal22: false,
    };
  },
  computed: {
    banner1() {
      return this.$store.state.banner1;
    },
    banner2() {
      return this.$store.state.banner2;
    },
    banner3() {
      return this.$store.state.banner3;
    },
    banner4() {
      return this.$store.state.banner4;
    },
    banner5() {
      return this.$store.state.banner5;
    },
  },
};
</script>
<style lang="less" scoped>
.home-web {
  padding-top: 0.08rem;
  .facts {
    display: flex;
    justify-content: center;
    padding-top: 1rem;
    .facts-img {
      width: 2.85rem;
      margin: 0 0.07rem;
      padding: 0.21rem 0.46rem;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 40px 0px rgba(0, 0, 0, 0.05);
      border-radius: 10px;
    }
    .facts-title {
      color: rgba(207, 42, 42, 1);
      font-family: "Poppins-Medium";
      font-size: 0.3rem;
    }
    .facts-content {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-Light";
      font-size: 0.16rem;
      margin: 0.2rem auto 0 auto;
    }
  }
  .power {
    width: 62%;
    margin: 1rem auto 1.2rem auto;
    .power-title {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-Light";
      font-size: 0.35rem;
      margin-bottom: 0.2rem;
    }
    .power-content {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-Light";
      font-size: 14px;
      text-align: left;
    }
  }
  .cores {
    background-color: rgba(249, 249, 249, 1);
    padding: 1.2rem 0;
    .title {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-Light";
      font-size: 0.35rem;
      margin-bottom: 0.3rem;
    }
    .cores-flexBox {
      display: flex;
      justify-content: center;
    }
    .cores-imgBox {
      width: 285px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 40px 0px rgba(0, 0, 0, 0.05);
      border-radius: 10px;
      padding: 0.28rem 0.1rem 0.3rem 0.1rem;
      margin: 0 0.07rem;
      img {
        width: 0.72rem;
      }
      .cores-title {
        color: rgba(32, 49, 82, 1);
        font-family: "Poppins-Regular";
        font-size: 0.16rem;
        margin: 0.22rem 0 0.21rem 0;
      }
      .cores-content {
        color: rgba(32, 49, 82, 1);
        font-family: "Poppins-Light";
        font-size: 0.12rem;
        text-align: center;
      }
    }
  }
  .Caas {
    display: flex;
    justify-content: center;
    padding-top: 1.2rem;
    padding-bottom: 1rem;
    .left {
      margin-right: 1.4rem;
      .left-title {
        color: rgba(32, 49, 82, 1);
        font-family: "Poppins-Light";
        font-size: 0.35rem;
        margin-top: 50px;
      }
      .left-content {
        color: rgba(32, 49, 82, 1);
        font-family: "Poppins-Light";
        font-size: 14px;
        width: 5.5rem;
        text-align: left;
        margin-top: 0.2rem;
        margin-bottom: 0.3rem;
      }
      .left-more {
        color: rgba(207, 42, 42, 1);
        font-family: "Poppins-Light";
        font-size: 0.18rem;
        text-align: left;
      }
    }
    .right {
      .img-box {
        width: 5rem;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 40px 0px rgba(0, 0, 0, 0.05);
        border-radius: 10px;
        display: flex;
        justify-content: space-between;
        padding: 0.1rem 0.27rem;
        margin-bottom: 0.2rem;
      }
      img {
        display: inline-block;
        width: 0.48rem;
        margin-right: 0.1rem;
      }
      .right-title {
        color: rgba(32, 49, 82, 1);
        font-family: "Poppins-Regular";
        font-size: 0.16rem;
        margin-bottom: 0.05rem;
      }
      .right-content {
        color: rgba(32, 49, 82, 1);
        font-family: "Poppins-Light";
        font-size: 0.12rem;
        text-align: left;
        margin-left: 0.1rem;
      }
    }
  }
  .product {
    padding-top: 1.2rem;
    padding-bottom: 1.2rem;
    background: linear-gradient(rgba(246, 246, 246, 1), rgba(255, 255, 255, 1));
    .product-title {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-Light";
      font-size: 0.35rem;
    }
    .product-content {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-Light";
      font-size: 14px;
      text-align: left;
      width: 62%;
      margin: 0.2rem auto 0.45rem auto;
    }
    .flex-box {
      display: flex;
      justify-content: center;
    }
    .img-box {
      margin: 0 0.45rem;
      img {
        width: 1.71rem;
      }
      .img-title {
        color: rgba(32, 49, 82, 1);
        font-family: "Poppins-Regular";
        font-size: 0.18rem;
      }
      .img-content {
        color: rgba(32, 49, 82, 1);
        font-family: "Poppins-Light";
        font-size: 0.12rem;
        margin-top: 0.2rem;
        margin-bottom: 0.3rem;
      }
      .img-more {
        color: rgba(207, 42, 42, 1);
        font-family: "Poppins-Light";
        font-size: 0.18rem;
      }
    }
  }
  .about {
    background-color: rgba(255, 255, 255, 1);
    padding-bottom: 1.5rem;
    .about-title {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-Light";
      font-size: 0.35rem;
    }
    .about-content {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-Light";
      font-size: 14px;
      text-align: left;
      width: 62%;
      margin: 0.2rem auto 0.4rem auto;
    }
    .about-more {
      color: rgba(207, 42, 42, 1);
      font-family: "Poppins-Light";
      font-size: 0.18rem;
      text-align: left;
      width: 62%;
      margin: auto;
    }
  }
  .about-redtea {
    background: linear-gradient(rgba(255, 255, 255, 1), rgba(246, 246, 246, 1));
    padding-bottom: 1.2rem;
    .demo-carousel {
      padding: 0 1rem;
    }
    .demo-title {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-Light";
      font-size: 0.35rem;
    }
    .demo-content {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-Light";
      font-size: 14px;
      text-align: left;
      margin: 0.2rem auto 0.4rem auto;
    }
    .demo-name {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-Light";
      font-size: 14px;
      text-align: right;
    }
  }
}
</style>